import { useState } from "react";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { RoomDialog } from "./RoomDialog";

export function CreateRoom() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <RoomDialog open={open} onOpenChange={setOpen}>
      <Button size="lg">
        <Plus size={18} />
        {t("home.create")}
      </Button>
    </RoomDialog>
  );
}
